import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { typography } from '../styles';

const styles = css`
  .InsideHeader_titleWrapper {
    background-color: rgba(183,150,65,1);
    font-family: ${typography.Serif};
    width: 100%;
    height: 110px;
    display: flex;
    align-items: center;
    h1 {
      line-height: 26px;
      color: #FFFFFF;
      font-size: 23px;
      font-weight: 300;
      letter-spacing: 1px;
      margin: 0;
      text-transform: uppercase;
      text-align: center;
    }
    @media (min-width: 992px) {
      background-color: rgba(183,150,65,.8);
      width: 100%;
      h1 {
        line-height: 36px;
        padding: 30px 0;
        color: #FFFFFF;
        font-size: 33px;
        font-weight: 300;
        letter-spacing: 3px;
        margin: 0;
        text-transform: uppercase;
        text-align: left;
      }
    }
  }
  @media (min-width: 992px) {
    background-image: url('/images/main-image-bg-fpo.jpg');
    background-size: cover;
    background-position: center center;
    height: 408px;
    width: 100%;
    display: flex;
    align-items: flex-end;
  }
`;

function InsideHeader({ h1, background }) {
  const mediaStyle = {};
  if (background) {
    mediaStyle.backgroundImage = `url('${buildThumbnailUrl(background, { width: 2000, height: 2000 })}')`;
  }
  return (
    <div
      className={styles}
      style={mediaStyle}
    >
      <div className="InsideHeader_titleWrapper">
        <div className="container">
          <h1>{h1}</h1>
        </div>
      </div>
    </div>
  );
}

InsideHeader.propTypes = {
  h1: PropTypes.node.isRequired,
  background: PropTypes.string,
};

InsideHeader.defaultProps = {
  h1: undefined,
  background: undefined,
};

export default InsideHeader;



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js